import React from 'react'

const ResumeCard = ({ title, subTitle, place, result, des }) => {
  return (
    <div className="w-full h-1/3 group flex">
      <div className="w-10 h-[6px] bg-Opacity mt-14 relative">
        <span className="absolute w-5 h-5 rounded-full -top-2 -left-3 flex justify-center items-center dark:bg-black bg-gray-700  bg-opacity-60">
          <span className="w-3 h-3 rounded-full dark:bg-bodyColor bg-blue-100 inline-flex dark:group-hover:bg-designColor group-hover:bg-blue-600 duration-300"></span>
        </span>
      </div>
      <div className="w-full dark:bg-black bg-white bg-opacity-20 dark:bg-opacity-25 duration-300  rounded-lg p-12 lgl:px-10 flex flex-col justify-center gap-6 lgl:gap-10 shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200">
        <div className="flex flex-col lgl:flex-row justify-between gap-4 lgl:gap-0 lgl:items-center">
          <div>
            <h3 className="text-xl md:text-2xl font-semibold dark:group-hover:text-white group-hover:text-black duration-300">
              {title}
            </h3>
            <p className="text-sm mt-2 dark:text-gray-300 text-gray-700 dark:group-hover:text-white group-hover:text-black duration-300">
              {subTitle}
            </p>
            <p className="text-sm mt-1 dark:text-gray-300 text-gray-700 dark:group-hover:text-white group-hover:text-black duration-300">
              {place}
            </p>
          </div>
          <div>
            <p className="px-4 py-2 text-blue-600 dark:text-designColor bg-black bg-opacity-25 rounded-lg flex justify-center items-center shadow-shadowOne dark:shadow-[#1c1e22] shadow-gray-200 text-sm font-medium">
              {result}
            </p>
          </div>
        </div>
        <p className="text-sm md:text-base font-medium dark:text-gray-400 text-black dark:group-hover:text-gray-300 group-hover:text-black duration-300">
          {des}
        </p>
      </div>
    </div>
  );
}

export default ResumeCard